import { JwtService } from "@/services/jwt.service";

/** Web Storage key where JWT is accessible */
export const jwtStorageKey = "auth:jwt";

/** Web Storage key where JWT refresh token is accessible */
export const jwtRefreshTokenKey = "auth:refreshToken";

/** JWT service instance */
export const jwtService = new JwtService({
  tokenGetter: () => localStorage.getItem(jwtStorageKey)
});
